module.exports = __webpack_public_path__ + "static/media/intro.af849822.mp3";